import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { timePeriodSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { ZendeskService } from '../../service';

export type TicketsExportConfig = typeof TicketsExportConfig._.Config;

export const TicketsExportConfig = IntegrationConfig.make({
  service: ZendeskService,
  name: Integration_Handler_Names_Enum.TicketsExport,
  configSchema: z.object({
    query: z.string().min(1),
    filters: z
      .object({
        createdAt: timePeriodSchema.optional(),
      })
      .optional(),
    fields: z.array(z.string().min(1)).optional(),
    queryCheck: z.string().optional(),
    queryCheckFilters: z
      .object({
        createdAt: timePeriodSchema.optional(),
      })
      .optional(),
  }),
});
